// extracted by mini-css-extract-plugin
module.exports = {"section":"ProductFunction_section__3ZpvM","title":"ProductFunction_title__3ouR8","functionContent":"ProductFunction_functionContent__3zp91"};